import React, { useState } from 'react';
import { useTemplateStore } from './templateStore';
import MinimalLexicalPreview from './MinimalLexicalPreview';

export interface TemplatePreviewDialogProps {
  open: boolean;
  onClose: () => void;
  template: {
    id: string;
    name: string;
    documentType: string;
    jurisdiction: string;
    format: 'pleading' | 'non_pleading' | 'form';
    lexicalJson?: unknown;
  } | null;
}

export const TemplatePreviewDialog: React.FC<TemplatePreviewDialogProps> = ({ open, onClose, template }) => {
  const { updateTemplate } = useTemplateStore();
  const [editable, setEditable] = useState(false);
  if (!open || !template) return null;

  // Preview is simplified; these are no longer needed

  return (
    <div className="fixed inset-0 z-[200]">
      <div className="absolute inset-0 bg-black/50 dark:bg-black/60" onClick={onClose} />
      <div className="absolute inset-4 bg-white dark:bg-gray-900 rounded shadow-xl flex flex-col overflow-hidden">
        <div className="flex items-center justify-between px-4 py-2 border-b border-gray-200 dark:border-gray-700">
          <div className="text-sm text-gray-900 dark:text-gray-200">
            <div className="font-semibold">Preview: {template.name}</div>
            <div className="text-gray-500 dark:text-gray-400">
              {template.documentType} • {template.jurisdiction} • {template.format}
            </div>
          </div>
          <div className="flex items-center gap-3">
            <label className="text-xs flex items-center gap-2 text-gray-700 dark:text-gray-300">
              <input type="checkbox" checked={editable} onChange={(e) => setEditable(e.target.checked)} />
              Enable editing
            </label>
            <button className="px-2 py-1 text-sm text-gray-700 dark:text-gray-300" onClick={onClose} aria-label="Close">
              ✕
            </button>
          </div>
        </div>
        <div className="flex-1 min-h-0">
          <MinimalLexicalPreview
            initialJson={template.lexicalJson as any}
            readOnly={!editable}
            onChange={(content) => {
              if (!editable) return;
              try {
                const parsed = JSON.parse(content);
                updateTemplate(template.id, { lexicalJson: parsed });
              } catch {}
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default TemplatePreviewDialog;


